import { useDoctorStore } from "@/stores/doctor";
import { showNotification } from "./general";
export function selectDoctor(doctor){
    const sd = useDoctorStore().selectDoctor(doctor);
    document.getElementById('input-doctor-id').value = sd.id;
    document.getElementById('input-doctor').value = sd.name;
    document.getElementById('ssb-text-doctor').innerHTML = '<span>' + sd.name + '</span>';
}
export function selectDate(e){
    useDoctorStore().selectDay(e.srcElement.value);
}
export function selectTime(time){
    document.getElementById('input-appointment-hour').value = time;
    document.getElementById('ssb-text-time').innerHTML = '<span>' + time + '</span>';
}
export function submitAppointment(){
    const fd = new FormData();
    const doctorid = document.getElementById('input-doctor-id');
    const params = {
        doctor_id: doctorid.value
    };
    var pcount = 0;
    const input = document.getElementsByClassName('input');
    for(var i = 0; i < input.length; i++){
        const validate = inputValidation(input[i]);
        if(validate.status){
            fd.append(input[i].getAttribute('name'), input[i].value);
            params[input[i].getAttribute('name')] = input[i].value;
            pcount = pcount + 1;
        }else{
            document.getElementById('warning-' + input[i].getAttribute('name')).innerHTML = '<small style="color: red; padding-left: 1rem; font-style: italic; font-weight: 300;">' + validate.toFixed[0].message + '</small>';
        }
    }
    if(pcount == input.length){
        useDoctorStore().submitAppointment(params);
    }else{
        showNotification('', 'Silakan ikuti petunjuk di bawah input', 5000, 'var(--primary-hover)');
        document.getElementById('section-appointment').scrollIntoView();
        // console.log('Parameter hanya : ' + pcount + ', diperlukan : ' + input.length);
    }
    // console.log(params);
}
export function resetTime(){
    document.getElementById('input-appointment-hour').value = '';
    document.getElementById('ssb-text-time').innerHTML = '<span>Pilih Jam</span>';
}
export function inputValidation(input){
    var validate = {status: false, toFixed: []};
    var falsenum = 0;
    if(input.hasAttribute('required')){
        if(!input.value){
            var required = {};
            required.name = 'required';
            required.message = input.getAttribute('label') + ' diperlukan';
            falsenum = falsenum + 1;
            validate.toFixed.push(required);
        }
    }
    if(falsenum == 0){
        validate.status = true;
    }
    // console.log(validate);
    return validate;
}
export function resetForm(){
    document.getElementById('ssb-text-doctor').innerHTML = '<span>Pilih Dokter</span>';
    document.getElementById('input-doctor-id').value = null;
    resetTime();
    const input = document.getElementsByClassName('input');
    for(var i = 0; i < input.length; i++){
        input[i].value = null;
    }
}